import { map, mergeMap, catchError } from 'rxjs/operators';
import { ofType } from 'redux-observable';
import { connectionService, noticeService } from '../../../common/services';
import * as actionTypes from './actionTypes';
import * as connectionsActions from './actions';
import * as _ from "lodash";

export function fetchConnection(action$) {
  return action$.pipe(
    ofType(actionTypes.FETCH_ONE),
    mergeMap(({ payload }) => {
      return connectionService.getConnectionById(payload)
        .pipe(
          map(res => connectionsActions.fetchConnectionSuccess(res.responceObject.records)),
          catchError(error => {
            console.log(error)
          })
        )
    })
  )
}
export function fetchConnections(action$) {
  return action$.pipe(
    ofType(actionTypes.FETCH_COLLECTION),
    mergeMap(({ payload }) => {
      return connectionService.getConnections(payload)
        .pipe(
          map(res => connectionsActions.fetchConnectionsSuccess(res.responceObject.records)),
          catchError(error => {
            console.log(error)
          })
        )
    })
  )
}
export function fetchHeaderImage(action$) {
  return action$.pipe(
    ofType(actionTypes.FETCH_HEADER_IMAGE),
    mergeMap(({ payload }) => {
      return connectionService.fetchHeaderImage(payload)
        .pipe(
          map(res => {
            if (res.responceObject.records && res.responceObject.records.length > 0) {
              const himage = _.sortBy(res.responceObject.records, ['created_at'])
              return connectionsActions.fetchHeaderImageSuccess(himage[himage.length - 1])
            } else {
              return connectionsActions.fetchHeaderImageSuccess('')
            }
          }),
          catchError(error => {
            console.log(error)
          })
        )
    })
  )
}
export function saveReadPost(action$) {
  return action$.pipe(
    ofType(actionTypes.SAVE_READ_POST),
    mergeMap(({ payload }) => {
      return noticeService.saveReadPost(payload)
        .pipe(
          map(res => connectionsActions.saveReadPostSuccess(res.responceObject.records)),
          catchError(error => {
            console.log(error)
          })
        )
    })
  )
}
export function getReadPosts(action$) {
  return action$.pipe(
    ofType(actionTypes.GET_READ_POSTS),
    mergeMap(({ payload }) => {
      return noticeService.getReadPosts(payload).pipe(
        map((res) =>
          connectionsActions.getReadPostsSuccess(res.responceObject.records)
        ),
        catchError((error) => {
          console.log(error);
        })
      );
    })
  );
}
